import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import { getStoreValue } from "../../gx/GxStore";
import { clearStore, StoreSettPosTax } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxList from '../../gx/GxList';


const MxSettSlsTaxList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const [storeSettPosTax, setStoreSettPosTax] = useSessionStorage('StoreSettPosTax', StoreSettPosTax);

  React.useEffect(() => {
    clearStore('StoreSettPosTax', storeSettPosTax);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const openForm = async (op, row) => {
    if (row === null) {
      storeSettPosTax.itTax = null;
    } else {
      storeSettPosTax.itTax = row.original.itTax;
    }
    setStoreSettPosTax(storeSettPosTax);
    navTo("sett-sls-tax-form");
  }

  return (
    <div>
      <GxList
        moduleName={trans('field.taxes')}
        fullscreen
        hasSearchBox={false}
        url="sett/tax"
        filter={`t_tax.inBranch='${getStoreValue('StoreSession', 'inBranch')}'`}
        onOpenForm={openForm}
        columns={[
          { id: "0", Header: "ID", accessor: "itTax", show: false },
          { id: "1", Header: trans('field.type'), accessor: "txTypeTaxGroup", width: '80%' },
          { id: "2", Header: trans('field.tax_perc'), accessor: row => FxTable.cellTo2r00(row["nuTaxPerc"]), width: '20%', align: 'right' },
        ]}
      />
    </div>

  );

}

export default MxSettSlsTaxList;
